<div class="mainColumn visible">
  <div class="theCard visible">
    <div class="authTitle">Registrierung</div>

    <!-- SCHRITT 1: Instanz + E-Mail -->
    <form [formGroup]="startForm" *ngIf="!bMailSent">
      <div id="middleColumn">
        <triv-input [data]="instanceName" [fGroup]="startForm"></triv-input>
        <triv-input [data]="email" [fGroup]="startForm"></triv-input>

        <div class="previewBox" *ngIf="showPreview">
          <div class="previewRow"><span class="label">Instanz:</span><span class="value">{{ instanceDomain }}</span></div>
          <div class="previewRow"><span class="label">E-Mail:</span><span class="value">{{ emailCtrl.value || '—' }}</span></div>
        </div>
        <mat-checkbox formControlName="termsAccepted" color="primary" required>
          Ich akzeptiere die <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> und die
          <a href="/nutzungsbedingungen" target="_blank">Nutzungsbedingungen</a>.
        </mat-checkbox>

        <button
          mat-raised-button
          type="button"
          style="width:100%"
          [disabled]="startForm.invalid || bInProgress"
          (click)="requestMail()"
          [ngStyle]="{
                'background-color': !bInProgress ? 'var(--mainColor)' : '',
                'color': 'var(--customWhite)'
              }">
          {{ startCtaLabel }}
        </button>

        <div *ngIf="errorMessage" style="color:#b00020; margin-top:.75rem;">{{ errorMessage }}</div>
      </div>
    </form>

    <!-- Hinweis nach Schritt 1 -->
    <div *ngIf="bMailSent && !token" class="previewBox" style="margin-top:1rem;">
      <b>E-Mail versendet.</b>
      <div>Bitte öffnen Sie den Link in der E-Mail, um die Registrierung abzuschließen.</div>
    </div>

    <!-- SCHRITT 2: Finale Registrierung (nur mit token) -->
    <form [formGroup]="completeForm" *ngIf="token">
      <div style="display:flex; flex-direction:column; gap:1rem;">
        <triv-input [data]="username" [fGroup]="completeForm"></triv-input>
        <app-password-input [data]="password" [fGroup]="completeForm"></app-password-input>
        <app-password-input [data]="passwordRepeat" [fGroup]="completeForm"></app-password-input>
        <triv-input [data]="companyName" [fGroup]="completeForm"></triv-input>
        <triv-input [data]="street" [fGroup]="completeForm"></triv-input>
        <triv-input [data]="houseNumber" [fGroup]="completeForm"></triv-input>
        <triv-input [data]="postalCode" [fGroup]="completeForm"></triv-input>
        <triv-input [data]="city" [fGroup]="completeForm"></triv-input>




        <button mat-raised-button color="primary" type="button"
                [disabled]="completeForm.invalid || bInProgress"
                (click)="completeRegistration()"
                [ngStyle]="{ 'background-color': !bInProgress ? 'var(--mainColor)' : '', 'color': 'var(--customWhite)' }">
          Registrierung abschließen
        </button>

        <div *ngIf="errorMessage" style="color:#b00020;">{{ errorMessage }}</div>
      </div>
    </form>
  </div>

  <!-- InfoPanel – zeigt immer die Features des gewählten Plans -->
  <div class="infoPanel" *ngIf="selectedFeatures?.length">
    <ul><li *ngFor="let f of selectedFeatures">{{ f }}</li></ul>
  </div>

  <footer-login></footer-login>
</div>
